import { ErrorMessageConfig, HttpErrorMessageConfig, ErrorStatusMessageConfig } from '@paysera/error-message-resolver';

const MAINTENANCE_STATUS = 503;
const INTERNAL_ERROR_STATUS = 500;

// resolveHttpErrorMessage ends on defaultErrorMessageCondition, which needs an initialised
// i18next. The admin apps never initialise one, so any response the earlier conditions do not
// match rejects instead of resolving, and useAct never reaches dispatchError. `custom` runs
// first, so it has to stay null wherever the chain still has an answer of its own.
// Each clause mirrors one library condition exactly, including when that condition declines to
// answer: maintenanceCondition needs a non-empty message list, and resolveByResponseErrors reads
// the first entry that carries a `message` key and returns it even when it is null. The status
// clause reads the same map the resolver receives, so a new map entry updates both sides at once.
const answersMaintenance = (errorResponse, data) => (
    errorResponse.getStatus() === MAINTENANCE_STATUS
    && data.error === 'maintenance'
    && Array.isArray(data.messages)
    && data.messages.length > 0
);

const answersListedError = (data) => {
    const errors = Array.isArray(data.errors) ? data.errors : [];
    const firstListed = errors.find(item => item && item.message !== undefined);

    return firstListed !== undefined && firstListed.message !== null;
};

const resolveOnlyWhatTheChainCannot = (errorMessage, statusMessages) => (errorResponse) => {
    const data = errorResponse.getData() || {};

    const chainHasAnAnswer = statusMessages[errorResponse.getStatus()] !== undefined
        || answersMaintenance(errorResponse, data)
        || answersListedError(data)
        || Boolean(data.error_description);

    return chainHasAnAnswer ? null : errorMessage;
};

const getErrorMessageConfig = (errorMessage) => {
    const statusMessages = {
        [INTERNAL_ERROR_STATUS]: errorMessage,
    };

    const httpConfig = new HttpErrorMessageConfig(errorMessage)
        .setStatus(new ErrorStatusMessageConfig().setConfig(statusMessages))
        .setCustom(resolveOnlyWhatTheChainCannot(errorMessage, statusMessages));

    return new ErrorMessageConfig(httpConfig, errorMessage);
};

export default getErrorMessageConfig;
